import { Box, Center, Spinner as ChakraSpinner } from '@chakra-ui/react'

/**
 * Loading Spinner Component
 * @param {string} size - Size of spinner (xs, sm, md, lg, xl)
 * @param {string} color - Color of spinner
 * @param {boolean} fullScreen - Whether to center in full screen
 */
export function Spinner({ size = 'md', color = 'brand.500', fullScreen = false, ...props }) {
  const spinner = <ChakraSpinner size={ size } color={ color } thickness="3px" speed="0.65s" { ...props } />

  if (fullScreen) {
    return (
      <Center minH="100vh">
        { spinner }
      </Center>
    )
  }

  return spinner
}

/**
 * Loading overlay for sections
 */
export function LoadingOverlay({ isLoading, children }) {
  if (!isLoading) return children

  return (
    <Box position="relative">
      { children }
      <Center
        position="absolute"
        top={ 0 }
        left={ 0 }
        right={ 0 }
        bottom={ 0 }
        bg="blackAlpha.600"
        zIndex="overlay"
      >
        <Spinner size="lg" color="white" />
      </Center>
    </Box>
  )
}

export default Spinner
